import { tuneSubscribeOptionInit } from "./TuneSubscribeOption";
import { normalizeTuneSubscribeOption } from "./TuneSubscribeOptionNormalizer";
import type { TuneSubscribeOption } from "./TuneSubscribeOption";

export type TuneRequest = {
  tuneOption: TuneSubscribeOption;
  rankScope?: string;
};

export const tuneRequestInit: TuneRequest = {
  tuneOption: tuneSubscribeOptionInit,
};

export const resolveTuneRequest = (
  request: Partial<TuneRequest> = {}
): TuneRequest => ({
  tuneOption: normalizeTuneSubscribeOption({
    ...tuneSubscribeOptionInit,
    ...request.tuneOption,
  }),
  ...(request.rankScope ? { rankScope: request.rankScope } : {}),
});
